// ReSharper disable InconsistentNaming
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import 'es6-promise/auto'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import vuetify from './plugins/vuetify'
//import _ from 'lodash'
import InputFacade from 'vue-input-facade'
import VueMeta from 'vue-meta'

//Object.defineProperty(Vue.prototype, '$_', { value: _ });

Vue.use(VueMeta);
Vue.config.productionTip = false;
Vue.use(InputFacade);

new Vue({
    render: h => h(App),
    vuetify,
    store,
    router
}).$mount('#app');
